import CompanySelector from "@/components/CompanySelector";
import FileUploader from "@/components/FileUploader";
import { deleteModal } from "@/components/deleteModal";
import useAuthStore from "@/store/useAuthStore";
import { resizeFile } from "@/utils/helpers";
import { Button, Flex, Group, Modal, NativeSelect, NumberInput, Select, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";

export default function DetailModal({ mutate, item, id, title, url }) {
  const [opened, { open, close }] = useDisclosure();
  const user = useAuthStore((s) => s.user);

  const isNew = !item;
  const label = isNew ? title + " 등록" : title + " 수정";

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      name: "",
      description: "",
    },
  });

  async function handleSubmit(vals) {
    const formData = new FormData();

    delete vals.image;

    const restData = JSON.stringify({
      ...vals,
      company: user?.company?.id,
    });

    if (file) {
      const uri = await resizeFile(file);
      formData.append("files.image", uri, file.name);
    }

    formData.append("data", restData);

    setLoading(true);

    if (isNew) {
      if (!file) return toast.error("사진을 업로드 해주세요");
      await axios({
        url: url,
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      });
      form.reset();
      setFile(null);
      toast.success("등록 완료");
    }

    if (!isNew) {
      await axios({
        url: `${url}/${id}`,
        method: "PUT",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      });
      toast.success("수정 완료");
    }

    setLoading(false);
    mutate();
    close();
  }

  async function handleDelete() {
    deleteModal({
      onConfirm: async () => {
        await axios({
          url: `${url}/${id}`,
          method: "DELETE",
        });
        mutate();
        toast.success("삭제 완료");
        close();
      },
    });
  }

  useEffect(() => {
    if (!item) return;
    form.setValues({
      ...item,
      description: item?.description || "",
      company: item?.company?.data?.id || "",
    });
  }, [item]);

  return (
    <>
      <Button onClick={open} compact={!isNew}>
        {isNew ? label : "관리"}
      </Button>

      <Modal opened={opened} onClose={close} title={label}>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput label="상차품명" placeholder="상차품명 입력" required {...form.getInputProps("name")} />
          <TextInput
            mb="lg"
            label="상차품 설명"
            placeholder="상차품 설명 입력"
            {...form.getInputProps("description")}
          />
          <FileUploader
            file={file}
            setFile={setFile}
            title="상차품 사진 업로드"
            accept="image/png,image/jpeg"
            url={form?.values?.image?.data?.attributes?.url}
            removeUrl={() => {
              form.setFieldValue("image", {});
            }}
          />

          <Group mt="lg">
            <Button color="red" disabled={isNew} onClick={handleDelete}>
              삭제
            </Button>
            <Button type="submit" loading={loading}>
              {label}
            </Button>
          </Group>
        </form>
      </Modal>
    </>
  );
}
